import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Package } from "lucide-react";
import { zl } from "@/lib/shop";
import { shopApi, useShopAuth } from "@/lib/shopAuth";
import RedfoxLayout from "./RedfoxLayout";
import { Button } from "@/components/ui/button";

export default function MyStoreOrders() {
  const auth = useShopAuth();
  const navigate = useNavigate();
  const [orders, setOrders] = useState(null);

  useEffect(() => {
    if (!auth?.ready) return;
    if (!auth.customer) { navigate("/sklep/moj-sklep"); return; }
    shopApi.get("/b2b/my/orders").then((r) => setOrders(r.data)).catch(() => setOrders([]));
  }, [auth?.ready, auth?.customer, navigate]);

  return (
    <RedfoxLayout>
      <div className="mx-auto max-w-3xl px-4 py-10" data-testid="redfox-orders">
        <h1 className="text-3xl uppercase italic mb-8" style={{ fontFamily: "'Oswald',sans-serif", fontWeight: 700 }}>Moje zamówienia</h1>
        {orders === null ? (
          <p className="text-neutral-500 py-16 text-center">Ładowanie…</p>
        ) : orders.length === 0 ? (
          <div className="grid place-items-center py-20 text-neutral-500">
            <Package className="h-10 w-10 mb-4" />
            <p className="mb-4">Nie masz jeszcze zamówień.</p>
            <Link to="/sklep/moj-sklep"><Button className="bg-red-600 hover:bg-red-500 text-white font-semibold">Przejdź do kolekcji</Button></Link>
          </div>
        ) : (
          <div className="space-y-3">
            {orders.map((o) => (
              <div key={o.number} data-testid={`redfox-order-${o.number}`} className="rounded-xl border border-white/10 bg-white/5 p-4">
                <div className="flex items-center justify-between gap-3">
                  <span className="font-mono font-bold text-red-400">{o.number}</span>
                  <span className="rounded-full bg-white/10 px-3 py-0.5 text-xs">{o.status}</span>
                </div>
                <p className="mt-1 text-xs text-neutral-400">{(o.created_at || "").slice(0, 10)} · {o.total_qty} szt. · {zl(Math.round((o.total_net || 0) * 100))}</p>
                {o.billing?.name && (
                  <p className="mt-1 text-xs text-neutral-400" data-testid={`redfox-order-billing-${o.number}`}>Faktura: <span className="font-semibold text-neutral-200">{o.billing.name}</span>{o.billing.nip ? ` (NIP ${o.billing.nip})` : ""}</p>
                )}
                <div className="mt-2 space-y-1">
                  {o.items.map((it, i) => (
                    <p key={i} className="text-sm text-neutral-300">{it.name} — {it.color} · {Object.entries(it.sizes || {}).map(([s, q]) => `${s}×${q}`).join(", ")}</p>
                  ))}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </RedfoxLayout>
  );
}
